import { CourseLineSubCategory } from './CourseLine';
import { Model, Nullable, Ordenable, Versionable } from './Model';
import { Question, QuestionTypeEnum } from './Question';

export default interface Activity extends Model, Ordenable, Versionable {
  name: string;
  type?: ActivityBlockType;
  activityType?: ActivityBlockType;
  questions: Question[];
  author: number;
  inBank: boolean;
  isPublicInBank: boolean;
  isActive?: boolean;
  shuffleQuestions: boolean;
  timeLimit: Nullable<number>;
}

export interface ActivityBankContext {
  id: number;
  name: string;
}

export interface ActivityBankItem extends Model {
  name: string;
  questionTypes: Partial<Record<QuestionTypeEnum, number>>;
  subCategory: Nullable<CourseLineSubCategory>;
  course: Nullable<ActivityBankContext>;
  module: Nullable<ActivityBankContext>;
  lessonBlock: Nullable<ActivityBankContext>;
  lesson: Nullable<ActivityBankContext>;
}

export enum ActivityBlockType {
  REGULAR = 'REGULAR',
  MANUAL_GRADE = 'MANUAL_GRADE',
  OPTIONAL = 'OPTIONAL',
  CONSOLIDATION = 'CONSOLIDATION',
}
